<script setup lang="ts">

import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { RowSlot } from '@shared/ui/other'
import { LinkTextPrimary } from '@shared/ui/links'
import { AppIcon } from '@shared/ui/icons'

import { useCustomerInfo } from '../model/customer-info.hook'

defineOptions({
  name: 'CustomerOtherInfo',
})

const {
  refDetails,
  refChangelogUrl,
} = useCustomerInfo()
</script>

<template>
  <div
    v-if="refDetails"
    class="customer-info-group"
  >
    <AppText name="body1-medium">
      Other
    </AppText>
    <div class="customer-info-group__list">
      <RowSlot label="Customer log">
        <LinkTextPrimary :href="refChangelogUrl">
          <AppIcon
            :icon="faArrowUpRightFromSquare"
            size="small"
          />
        </LinkTextPrimary>
      </RowSlot>
      <RowSlot label="Created at">
        <AppText name="body1">
          {{ refDetails.created_at }}
        </AppText>
      </RowSlot>
      <RowSlot label="Updated at">
        <AppText name="body1">
          {{ refDetails.updated_at }}
        </AppText>
      </RowSlot>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./CustomerInfoGroup.scss" />
